<template>
  <div class="organization" id="organization">
    <div class="organization-top">
      <span></span>
      <p>{{ $t("organization.title") }}</p>
      <p>{{ $t("organization.describe") }}</p>

    </div>
    <div class="organization-mid">
      <div class="organization-mid-type">
        <span v-for="(item, index) in type" :key="index">{{ item }}</span>
      </div>
      <div class="organization-mid-position">
        <p v-for="(item, index) in position " :key="index">
          <span v-for="(ite, indx) in item" :key="indx">{{ ite }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    type() {
      return this.$t('organization.type')
    },
    position() {
      return this.$t('organization.position')
    }
  }
}
</script>
<style lang="less" scoped>
.organization {
  width: 1060px;
  margin: 0 auto;
}

.organization-top {
  text-align: center;

  span {
    display: inline-block;
    width: 40px;
    height: 0px;
    border: 3px solid #FF5200;
    margin-bottom: 60px;
  }

  p:nth-of-type(1) {
    font-size: 40px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #000000;
    line-height: 56px;

  }

  p:nth-of-type(2) {
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 22px;

  }
}

.organization-mid {
  width: 1060px;
  height: 440px;
  background-image: url("@/assets/organization.png");
  background-position: center;
  background-size: cover;
  position: relative;
  font-size: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #000000;

  .organization-mid-type {
    span {
      position: absolute;
    }

    span:nth-child(1) {
      top: 310px;
      left: -20px;
    }

    span:nth-child(2) {
      top: 180px;
      left: 60px;
    }

    span:nth-child(3) {
      top: 70px;
      left: 220px;
    }

    span:nth-child(4) {
      top: 70px;
      right: 240px;
    }

    span:nth-child(5) {
      top: 180px;
      right: 60px;
    }

    span:nth-child(6) {
      top: 310px;
      right: -25px;
    }
  }

  .organization-mid-position {
    p:nth-child(1) {
      position: absolute;
      top: 100px;
      left: 470px;
    }

    span {
      display: inline-block;
      width: 120px;
      text-align: center;
    }

    p:nth-child(2) {



      span:nth-child(1) {
        position: absolute;
        top: 320px;
        left: 310px;
      }

      span:nth-child(2) {
        position: absolute;
        top: 240px;
        left: 420px;
        text-align: left;
      }

      span:nth-child(3) {
        position: absolute;
        top: 190px;
        left: 465px;
      }

      span:nth-child(4) {
        position: absolute;
        top: 240px;
        right: 380px;
        text-align: right;
      }

      span:nth-child(5) {
        position: absolute;
        top: 320px;
        right: 310px;
      }
    }

    p:nth-child(3)>span:nth-child(1) {
      position: absolute;
      bottom: 110px;
      left: 470px;
      color: #fff;
    }

    p:nth-child(3)>span:nth-child(2) {
      position: absolute;
      bottom: 35px;
      left: 470px;
      color: #fff;
    }

  }
}

@media screen and (max-width: 1080px) {
  .organization {
    width: 108rem;
    margin: 0 auto;
  }

  .organization-top {
    text-align: center;

    span {
      display: inline-block;
      width: 10rem;
      height: 0px;
      border: 0.5rem solid #FF5200;
      margin-bottom: 7.6rem;
    }

    p:nth-of-type(1) {
      font-size: 5.3rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 5.3rem;

    }

    p:nth-of-type(2) {
      font-size: 3rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.5);
      line-height: 4.3rem;
      margin-top: 2rem;

    }
  }

  .organization-mid {
    width: 93.4rem;
    height: 35.8rem;
    background-image: url("@/assets/organization.png");
    background-position: center;
    background-size: cover;
    position: relative;
    font-size: 2.5rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #000000;
    margin: 0 auto;
    margin-top: 4rem;
    line-height: 3.5rem;



    .organization-mid-type {
      span {
        position: absolute;
        display: inline-block;
        width: 13rem;
      }

      span:nth-child(1) {
        top: 23rem;
        left: -3.1rem;
        text-align: right;
      }

      span:nth-child(2) {
        top: 13rem;
        left: 4rem;
        text-align: right;
      }

      span:nth-child(3) {
        top: 3rem;
        left: 19rem;
        text-align: right;
      }

      span:nth-child(4) {
        top: 3rem;
        right: 21rem;
        text-align: left;
      }

      span:nth-child(5) {
        top: 13rem;
        right: 5rem;
      }

      span:nth-child(6) {
        top: 23rem;
        right: -3.1rem;
      }
    }

    .organization-mid-position {
      p:nth-child(1) {
        position: absolute;
        top: 5.5rem;
        left: 41rem;
      }

      span {
        display: inline-block;
        width: 12rem;
        text-align: center;
      }

      p:nth-child(2) {



        span:nth-child(1) {
          position: absolute;
          top: 29rem;
          left: 22.5rem;
        }

        span:nth-child(2) {
          position: absolute;
          top: 21rem;
          left: 32rem;
        }

        span:nth-child(3) {
          position: absolute;
          top: 14.5rem;
          left: 41rem;
        }

        span:nth-child(4) {
          position: absolute;
          top: 21rem;
          right: 28rem;
        }

        span:nth-child(5) {
          position: absolute;
          top: 29rem;
          right: 23.5rem;
        }
      }

      p:nth-child(3)>span:nth-child(1) {
        position: absolute;
        bottom: 8rem;
        left: 41rem;
        color: #fff;
      }

      p:nth-child(3)>span:nth-child(2) {
        position: absolute;
        bottom: 0rem;
        left: 41rem;
        color: #fff;
      }

    }
  }
}
</style>